export const carouselContainerStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  overflow: 'hidden',
};

// `fixed` + four-side inset (no 100vw/100vh) pins the carousel to the exact WebView frame. On iOS
// `vh`/`vw` resolve to the largest, un-keyboarded viewport and do NOT shrink when the soft keyboard
// resizes the WebView — that mismatch left an uncovered white strip under the login card. Insets
// always track the live frame, so the background stays full-bleed with the keyboard open.
export const nativeCarouselContainerStyle = {
  position: 'fixed',
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  overflow: 'hidden',
};

export const imageCarouselStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  zIndex: 0,
};

export const carouselSlideStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  opacity: 0,
  transition: 'opacity 1.5s ease-in-out',
};

export const activeStyle = {
  opacity: 1,
};

const overlayBaseStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
};

export const getOverlayStyle = theme => ({
  ...overlayBaseStyle,
  background: `linear-gradient(to right, ${theme.palette.primary.dark}70 0%, rgba(0, 0, 0, 0.1) 100%)`,
});
